import { Box } from '@mui/material';
import { Sidebar } from './Sidebar';
import {} from '@lingaai/shared-hooks';
import { useCurrentUser } from '@lingaai/user-management';

export function Layout({ children }: { children: React.ReactNode }) {
  const { data: user } = useCurrentUser();
  const showSidebar = user?.role !== 'portco';

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {showSidebar && <Sidebar />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          bgcolor: 'background.default',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
